import React from 'react';
import {
	downloadChecklistText, downloadDocumentsText, triggerDownload,
} from '../../data/journeys/journeyProgress';

function JourneyResourcesPanel({ journey }) {
	const slug = journey.slug;

	function downloadEmergencyCard() {
		const lines = [
			'EVEREST BASE CAMP — EMERGENCY CONTACTS',
			`Generated: ${new Date().toLocaleDateString()}`,
			'',
			...(journey.emergencyContacts || []).map((c) => `${c.label}: ${c.number} — ${c.note}`),
			'',
			'AMS: DESCEND IMMEDIATELY if symptoms worsen.',
			'Insurance emergency number: _______________',
		];
		triggerDownload(`${slug}-emergency-contacts.txt`, lines.join('\n'));
	}

	function downloadPermitSummary() {
		const text = [
			'EBC PERMIT SUMMARY (verify fees at NTB before travel)',
			'',
			'1. Sagarmatha National Park — NPR 3,000 (foreigner), NPR 1,500 (SAARC)',
			'   Where: NTB Bhrikutimandap Kathmandu OR Monjo gate',
			'   Hours: Sun–Fri 09:00–17:00',
			'',
			'2. Khumbu Pasang Lhamu RM — NPR 2,000 (foreigner)',
			'   Where: Lukla airport counter ONLY',
			'',
			'TIMS: NOT required for Khumbu/Everest region',
			'',
			'Official: https://ntb.gov.np/en/plan-your-trip/before-you-come/park-entry-fees',
		].join('\n');
		triggerDownload(`${slug}-permits.txt`, text);
	}

	function downloadTrekSummary() {
		const lines = [`${journey.title} — Day by day`, ''];
		(journey.trekDays || []).forEach((d) => {
			lines.push(`Day ${d.day}: ${d.title}`);
			lines.push(`  Sleep: ${d.sleep} | Alt: ${d.altitude} | ${d.distance} | ${d.time}`);
			if (d.teahouses) lines.push(`  Teahouses: ${d.teahouses}`);
			if (d.notes) lines.push(`  Note: ${d.notes}`);
			lines.push('');
		});
		triggerDownload(`${slug}-trek-days.txt`, lines.join('\n'));
	}

	return (
		<div className="guided-panel">
			<h3 className="guided-panel__title">Maps, GPX & offline downloads</h3>
			<p className="guided-panel__intro">Download everything before you leave home — the trail has no reliable WiFi above Namche.</p>

			{journey.gpxMap && (
				<section className="guided-resources__section">
					<h4>Route maps & GPX</h4>
					<p>{journey.gpxMap.description}</p>
					<ul className="guided-resources__links">
						{journey.gpxMap.resources.map((r) => (
							<li key={r.url}>
								<a href={r.url} target="_blank" rel="noopener noreferrer">{r.label} →</a>
								{r.note && <small>{r.note}</small>}
							</li>
						))}
					</ul>
					{journey.gpxMap.offlineApps && (
						<div className="guided-resources__apps">
							<strong>Offline map apps:</strong>
							<ul>
								{journey.gpxMap.offlineApps.map((a) => (
									<li key={a.name}><strong>{a.name}</strong> ({a.platforms}) — {a.note}</li>
								))}
							</ul>
						</div>
					)}
				</section>
			)}

			{journey.officialPdfs && (
				<section className="guided-resources__section">
					<h4>Official links & PDFs</h4>
					<ul className="guided-resources__links">
						{journey.officialPdfs.map((pdf) => (
							<li key={pdf.id}>
								<a href={pdf.url} target="_blank" rel="noopener noreferrer">{pdf.label} →</a>
								<small>{pdf.description}</small>
							</li>
						))}
					</ul>
				</section>
			)}

			<section className="guided-resources__section">
				<h4>Offline downloads</h4>
				<div className="guided-resources__downloads">
					<button type="button" className="guided-panel__download" onClick={() => triggerDownload(`${slug}-packing.txt`, downloadChecklistText(journey, { packing: {} }))}>
						Packing checklist
					</button>
					<button type="button" className="guided-panel__download" onClick={() => triggerDownload(`${slug}-documents.txt`, downloadDocumentsText(journey, { documents: {} }))}>
						Documents wallet
					</button>
					<button type="button" className="guided-panel__download" onClick={downloadEmergencyCard}>
						Emergency contacts card
					</button>
					<button type="button" className="guided-panel__download" onClick={downloadPermitSummary}>
						Permit fee summary
					</button>
					<button type="button" className="guided-panel__download" onClick={downloadTrekSummary}>
						Day-by-day trek summary
					</button>
				</div>
			</section>

			{journey.connectivity && (
				<section className="guided-resources__section">
					<h4>Connectivity on trail</h4>
					{journey.connectivity.sim.map((s) => (
						<div key={s.provider} className="guided-resources__sim">
							<strong>{s.provider}</strong> — {s.recommendation}
							<br />
							<small>{s.trailSignal}</small>
							{s.officialUrl && <a href={s.officialUrl} target="_blank" rel="noopener noreferrer"> Official site →</a>}
						</div>
					))}
					<p><small>{journey.connectivity.wifi.tip}</small></p>
				</section>
			)}
		</div>
	);
}

export default JourneyResourcesPanel;
